export class BmwDocument {
	public Id: number;
	public Json: Json;
	public Url: string;
}

export class Json {
	public Brand: string;
	public Dealership: string;
	public CampaignNumber: string;
	public StatusOptions: StatusOptions[];
	public Holder: Owner;
	public Vehicles: Vehicle[];
}

export interface StatusOptions {
	Key: number;
	Value: string;
	IsFormVisible: boolean;
}

export class Owner {
	public Surname: string;
	public Name: string;
	public Address: string;
	public Cap: string;
	public City: string;
	public StreetNumber: string;
	public State: string;
	public Province: string;
	public Email: string;
}

export class Vehicle {
	public Guuid: string;
	public Chassis: string;
	public LicensePlate: string;
	public Status: Status;
	public NewOwner: Owner | null;
	public ComplaintDate: string;
	public Other: string;
}

export class Status {
	Key: number | undefined;
	Value: string | undefined;
}
